/**
 * Shared layout for static legal/compliance pages. Keeps typography consistent
 * with the rest of the site.
 */
export default function LegalPageLayout({ title, eyebrow, lastUpdated, children, testId }) {
  return (
    <div data-testid={testId}>
      <section className="bg-navy py-14 text-white sm:py-16">
        <div className="mx-auto max-w-4xl px-5 sm:px-8">
          {eyebrow && (
            <div className="text-[10px] font-semibold uppercase tracking-[0.2em] text-gold">
              {eyebrow}
            </div>
          )}
          <h1 className="mt-3 font-serif text-3xl leading-tight sm:text-5xl">{title}</h1>
          {lastUpdated && (
            <p className="mt-4 text-xs uppercase tracking-[0.18em] text-white/60">
              Last updated: {lastUpdated}
            </p>
          )}
        </div>
      </section>

      <article className="mx-auto max-w-3xl px-5 py-12 sm:px-8 sm:py-16">
        <div className="legal-prose space-y-6 text-[15px] leading-relaxed text-[#1A1F36]">
          {children}
        </div>
      </article>
    </div>
  );
}
